<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select v-model="params.type" size="small" placeholder="请选择类型" clearable @change="getList('status')">
        <el-option :label="item.label" :value="item.value" v-for="item in types" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getList('status')"
        style="margin-right: 20px">搜索</el-button>
      <el-button type="primary" size="small" @click="addAndEdit('add')" style="margin-right: 20px">新增</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" height="600">
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="跑马灯类型" align="center" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type | getTagStyle">{{ scope.row.type | getMarqueeTypeName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="跑马灯内容" align="center" width="300">
        <template slot-scope="scope">
          {{ scope.row.content || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="url" label="跑马灯链接" align="center" width="300">
        <template slot-scope="scope">
          {{ scope.row.url || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="active" label="是否开启" align="center" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.active">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" icon="el-icon-edit" @click="addAndEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <!-- <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination> -->
    <!-- 新增、修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @before-close="handleClose"
      @close="handleClose">
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="跑马灯内容:" size="small" prop="content" style="width: 480px">
          <el-input v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item size="small" label="类型:" prop="type" style="width: 480px">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option :label="item.label" :value="item.value" v-for="item in types" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType" style="width:480px">
          <el-select v-model.number="link_type" size="small" placeholder="跳转方式">
            <el-option v-for="item in linkTypeList" :value="item.value" :label="item.label"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" prop="link" v-if="link_type == 1" style="width:480px">
          <el-input size="small" v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item label="链接地址:" prop="link" v-if="link_type == 2" style="width:480px">
          <el-select v-model="form.url" size="small" placeholder="链接地址" filterable>
            <el-option v-for="item in linkList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内链ID" prop="inLinkId" style="width:480px" v-if="showInnerId">
          <el-input size="small" v-model="inLinkId"></el-input>
        </el-form-item>
        <el-form-item size="small" label="是否开启:" prop="active" style="width: 480px">
          <el-select v-model="form.active" placeholder="请选择是否开启">
            <el-option :label="item.label" :value="item.value" v-for="item in enables" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAnnounceList,
  addAnnounce,
  updateAnnounce,
  deleteAnnounce,
} from "@/api/marquee.js";
import { uniteDate } from "@/utils/validator.js";
import { getMarqueeTypeName, marqueeTypes } from "../../../config";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        type: null,
        pageNumber: 1,
        pageSize: 10,
      },
      rules: {
        content: [
          { required: true, message: "请输入跑马灯内容", trigger: "blur" },
        ],
      },
      enables: [
        {
          label: "开启",
          value: true,
        },
        {
          label: "关闭",
          value: false,
        },
      ],
      types: marqueeTypes,
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        content: undefined, // 跑马灯内容
        url: "", // 跑马灯链接
        type: 0, // 0-视频，1-动漫
        active: true, // 是否启用
      },
      link_type: 1,
      inLinkId: "",
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      linkList: [
        { label: "会员中心", value: "yinseinner://vip_page" },
        { label: "金币钱包", value: "yinseinner://wallet_page" },
        { label: "抽奖", value: "yinseinner://Activity_page" },
        { label: "帖子详情页", value: "yinseinner://postdetail?id=" },
        { label: "视频详情", value: "yinseinner://video_page?id=" },
        { label: "专题导航", value: "yinseinner://navigation" },
        { label: "排行榜", value: "yinseinner://rankingList" },
        { label: "福利任务", value: "yinseinner://taskHall" },
        // { label: "预售界面", value: "yinseinner://advancePage" },
        { label: "亚模块-社区", value: "yinseinner://module_community?id=" },
        // { label: "社区-专题", value: "yinseinner://topics_community?id=" },
      ],
    };
  },
  computed: {
    showInnerId() {
      return this.form.url.indexOf('id=') > -1
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      getAnnounceList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增播单
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        Object.assign(this.form, param)
        if (this.linkList.findIndex(v => this.form.url.indexOf(v.value) > -1) > -1) {
          this.link_type = 2;
        }
        if (this.showInnerId) {
          const splitArr = this.form.url.split("=");
          this.form.url = splitArr[0] + "=";
          this.inLinkId = splitArr[1];
          console.log(this.showInnerId, this.form.url, this.inLinkId);
        } else {
          this.form.url = this.form.url;
        }
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = Object.assign({}, this.form);
          if (this.showInnerId &&
            !this.inLinkId
          ) {
            this.$message({
              type: "error",
              message: "请输入内链ID",
            });
            return;
          }
          if (this.showInnerId) {
            form.url = form.url + this.inLinkId;
          }
          addAnnounce(form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = Object.assign({}, this.form);
          if (this.showInnerId &&
            !this.inLinkId
          ) {
            this.$message({
              type: "error",
              message: "请输入内链ID",
            });
            return;
          }
          if (this.showInnerId) {
            form.url = form.url + this.inLinkId;
          }
          updateAnnounce(form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.id}</span>跑马灯, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          deleteAnnounce(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.content = undefined;
      this.form.url = "";
      this.form.active = true;
      this.form.type = 0;
      this.link_type = 1;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
  filters: {
    getMarqueeTypeName
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}

/deep/ .el-form-item__content {
  display: flex;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}

/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
</style>
